// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCheckSquareOutlinedSvg from "@fishx/icons-svg/es/asn/PCheckSquareOutlined";
import FishxIcon from '../components/FishxIcon';

var PCheckSquareOutlined = function PCheckSquareOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCheckSquareOutlinedSvg
  }));
};

PCheckSquareOutlined.displayName = 'PCheckSquareOutlined';
export default React.forwardRef(PCheckSquareOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCheckSquareOutlined.js
// module id = 3284
// module chunks = 0